<template>
  <v-row>
    <v-col>
      <v-text-field
        label="Orsak"
        hint="Obligatorisk"
        outlined
        v-model="model"
        :disabled="readonly"
      />
    </v-col>
  </v-row>
</template>

<script>
import { required } from '@/common/validationRules'
import { sync } from 'vuex-pathify'

export default {
  name: 'TibBannerReasonInput',

  props: {
    readonly: Boolean
  },

  data() {
    return { required }
  },

  computed: {
    model: sync('tibBanner/model@reason')
  }
}
</script>
